import { ChangeDetectorRef, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { BedienungsanleitungService } from '../../service/settings/bedienungsanleitung.service';
import { ConfirmDialogService } from '../../service/common/dialog/confirm-dialog.service';
import { RedispatchFile } from '../../domain/model/redispatch-file';
import { NotificationService } from '../../service/common/notification/notification.service';
import { HttpEventType } from '@angular/common/http';

@Component({
    selector: 'redispatch-settings-bedienungsanleitung',
    templateUrl: './settings-bedienungsanleitung-page.component.html',
    styleUrls: [
        './settings-bedienungsanleitung-page.component.scss',
    ],
    standalone: false,
})
export class SettingsBedienungsanleitungPageComponent implements OnInit {

    @ViewChild('fileInput', { static: true }) file: ElementRef<HTMLInputElement>;
    currentFile: RedispatchFile | null = null;

    private dialogService = inject(ConfirmDialogService);
    private uploadService = inject(BedienungsanleitungService);
    private notificationService = inject(NotificationService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    ngOnInit(): void {
        this.loadData();
    }

    onFileChanged() {
        if (this.file?.nativeElement?.files[0]) {
            this.upload(this.file.nativeElement.files[0]);
        }
    }

    private async upload(file: File) {
        let message = `Möchten Sie die Datei '${file.name}' wirklich hochladen?`;
        if (this.fileExist) {
            message = `Es existiert bereits eine Bedienungsanleitung '${this.currentFile.name}'. Diese wird beim Hochladen überschrieben. ${message}`;
        }

        if (await this.dialogService.confirm(message, 'Bedienungsanleitung upload')) {
            this.uploadService.upload(file).subscribe({
                next: (value) => {
                    if (value.type === HttpEventType.Response) {
                        this.notificationService.success('Die Bedienungsanleitung wurde erfolgreich hinterlegt');
                        this.rollbackToInitial();
                    }
                },
                error: () => {
                    this.notificationService.failure('Beim Hochladen trat leider ein Fehler auf');
                    this.rollbackToInitial();
                },
            });
        } else {
            this.rollbackToInitial();
        }

    }

    private rollbackToInitial(): void {
        this.loadData();
        this.resetFileInput();
    }

    private loadData(): void {
        this.uploadService.isAvailable().subscribe({
            next: (value) => {
                this.currentFile = value;
                this.changeDetectorRef.markForCheck();
            },
            error: () => {
                this.currentFile = null;
                this.changeDetectorRef.markForCheck();
            },
        });
    }

    private resetFileInput(): void {
        this.file.nativeElement.value = '';
    }

    download() {
        this.uploadService.download();
    }

    get fileExist(): boolean {
        return !!this.currentFile;
    }

    async delete() {
        if (this.fileExist && await this.dialogService.confirm(
            `Möchten Sie die Datei '${this.currentFile.name}' wirklich löschen?`,
            'Bedienungsanleitung löschen',
            'warn',
            'Löschen',
        )) {
            this.uploadService.delete().subscribe({
                next: () => {
                    this.notificationService.success('Die Bedienungsanleitung wurde gelöscht');
                    this.rollbackToInitial();
                },
                error: () => {
                    this.notificationService.failure('Beim Löschen trat leider ein Fehler auf');
                    this.rollbackToInitial();
                },
            });
        }
    }
}
